import { Address } from 'types/customers'

export type GetCustomerAddressOptions = {
  usePostalCode?: boolean
  useFullAddress?: boolean
  useAddressExcludingCountry?: boolean
}

export const getCustomerAddress = (address: Address, options?: GetCustomerAddressOptions) => {
  const addressLines = [address?.addressLine1, address?.addressLine2, address?.city]
  if (options?.useFullAddress) {
    addressLines?.push(address?.postalCode, address?.stateCode, address?.countryCode)
  } else if (options?.useAddressExcludingCountry) {
    addressLines?.push(address?.postalCode, address?.stateCode)
  } else if (options?.usePostalCode) {
    addressLines?.push(address?.postalCode)
  } else {
    addressLines?.push(address?.country)
  }
  return addressLines?.filter(Boolean)?.join(', ')
}
